<template>
  <b-modal title="Lista de Orçamentos" v-model="show" size="xl">
    <div class="screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ORÇAMENTOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterOrcamentos(filtro)" :fields="fields.orcamento">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(total)="data">
          <div>
            <p>{{ formatter.format(data.item.total) }}</p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="carregar(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <template #modal-footer>
      <b-form inline>
        <b-form-input
          id="orcamento-filter-id"
          type="number"
          size="sm"
          class="m-1 p-1"
          placeholder="0"
          v-model="filtro.id"
        />
        <b-form-input
          id="orcamento-filter-titulo"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pelo título do orçamento"
          v-model="filtro.titulo"
        />
        <b-form-input
          id="orcamento-filter-cliente"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pelo cliente"
          v-model="filtro.cliente"
        />
        <b-form-input
          id="orcamento-filter-status"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pelo status"
          v-model="filtro.status"
        />
        <b-icon icon="search" variant="info" scale="1.2" class="m-1 pr-5" />
        <b-button variant="secondary" @click="show = !show">Fechar</b-button>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useOrcamentoStore } from "@/stores/OrcamentoStore";
import Orcamento from "@/models/Orcamento";
import TableFields from "@/tools/TableFields";

export default {
  name: "ModalDeOrcamentoList",

  data() {
    return {
      show: false,
      selecionado: null,
      fields: new TableFields(),
      filtro: {
        id: 0,
        total: 0,
        titulo: "",
        cliente: "",
        data: "",
        status: "",
      },
      editing: new Orcamento(),
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  methods: {
    carregar(orcamento) {
      this.$emit("setOrcamento", orcamento);
      this.show = !this.show;
    },

    call(orcamento) {
      this.show = !this.show;
      this.editing = orcamento;
    },
  },

  setup() {
    const store = useSgcqStore();
    const orcamentoStore = useOrcamentoStore();
    const { getFilterOrcamentos } = storeToRefs(orcamentoStore);

    return {
      store,
      orcamentoStore,
      getFilterOrcamentos,
      usuario: store.getUser,
    };
  },
};
</script>

<style lang="scss" scoped>
.screen-list {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 68vh;
}

#orcamento-filter-id {
  width: 5rem;
}

#orcamento-filter-titulo {
  width: 25rem;
}

#orcamento-filter-cliente {
  width: 15rem;
}

#orcamento-filter-data {
  width: 10rem;
}

#orcamento-filter-status {
  width: 10rem;
}
</style>
